import React from "react";
import Services1 from "../Assets/services1.png";
import Services2 from "../Assets/services2.png";


function Services() {
const serviceCards = [
  {
    number: "01",
    title: "Engineering & Design Services",
    description:
      "Structured engineering support for automation, electrical systems and industrial solution planning.",
    points: [
      "System design and application engineering",
      "Control panel and electrical design",
      "Automation architecture planning",
      "Project-oriented engineering coordination",
    ],
    color: "#2F4EAA",
  },
  {
    number: "02",
    title: "Installation & Commissioning",
    description:
      "On-site implementation services focused on seamless integration, validation and performance readiness.",
    points: [
      "On-site installation and integration",
      "Testing, commissioning and validation",
      "Performance optimization",
      "Deployment readiness support",
    ],
    color: "#F39A09",
  },
  {
    number: "03",
    title: "Retrofit & Modernization",
    description:
      "Upgrade-focused services that improve performance, efficiency and compatibility in existing systems.",
    points: [
      "Legacy system upgrades",
      "Energy efficiency retrofits",
      "Emission compliance retrofits",
      "Modernization of aging infrastructure",
    ],
    color: "#E83E79",
  },
  {
    number: "04",
    title: "After-Sales Support & Maintenance",
    description:
      "Support services designed to help customers maintain reliability and smooth system operation after deployment.",
    points: [
      "Preventive maintenance",
      "Breakdown maintenance",
      "Technical support and troubleshooting",
      "Spare management and system health checks",
    ],
    color: "#0B8A94",
  },
  {
    number: "05",
    title: "Consulting & Energy Audits",
    description:
      "Advisory services that help customers make informed decisions on performance improvement and sustainability.",
    points: [
      "Energy efficiency assessments",
      "Sustainability consulting",
      "Technology selection",
      "ROI evaluation support",
    ],
    color: "#F0642B",
  },
];
  const serviceBenefits = [
    "Reliable execution support",
    "Improved operational readiness",
    "Long-term system performance",
    "Reduced downtime risks",
    "Smarter upgrade decisions",
    "Better energy and sustainability outcomes",
  ];

  return (
    <div style={{ backgroundColor: "#f7fbff", overflowX: "hidden" }}>
     <section
  style={{
    background:
      "linear-gradient(135deg, #edf7ff 0%, #d8ecfb 45%, #f7fbff 100%)",
    padding: "90px 0 70px 0",
    position: "relative",
    overflow: "hidden",
  }}
>
  <div
    style={{
      position: "absolute",
      top: "30px",
      left: "-70px",
      width: "220px",
      height: "220px",
      borderRadius: "50%",
      background: "rgba(29,169,232,0.10)",
      filter: "blur(10px)",
      animation: "floatY 5s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    style={{
      position: "absolute",
      bottom: "20px",
      right: "-60px",
      width: "240px",
      height: "240px",
      borderRadius: "50%",
      background: "rgba(11,92,173,0.10)",
      filter: "blur(10px)",
      animation: "floatY 6s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    className="container"
    style={{
      position: "relative",
      zIndex: 2,
    }}
  >
    <div className="row align-items-center gy-5">
      <div className="col-lg-6">
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#e6f4ff",
            color: "#0B5CAD",
            padding: "10px 18px",
            borderRadius: "30px",
            fontWeight: 700,
            fontSize: "14px",
            marginBottom: "18px",
            animation: "fadeUp 1s ease",
          }}
        >
          SERVICES WE DELIVER
        </div>

        <h1
          style={{
            color: "#0B5CAD",
            fontWeight: 800,
            fontSize: "clamp(2.2rem, 5vw, 3.8rem)",
            lineHeight: "1.15",
            marginBottom: "18px",
            animation: "fadeUp 1.1s ease",
          }}
        >
          Service Support
          <br />
          Beyond Delivery
        </h1>

        <p
          style={{
            color: "#4a5568",
            fontSize: "17px",
            lineHeight: "1.9",
            marginBottom: "24px",
            animation: "fadeUp 1.2s ease",
          }}
        >
          Electromates supports customers through engineering, upgrades,
          maintenance, consulting and commissioning services that help ensure
          systems remain efficient, reliable and future-ready.
        </p>

        <div className="row g-3">
          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                5
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Service Areas
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                On-Site
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Execution Support
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Long-Term
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Performance Focus
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div
          style={{
            width: "100%",
            position: "relative",
            zIndex: 1,
            borderRadius: "28px",
            overflow: "hidden",
            animation: "zoomInSoft 1.2s ease",
            aspectRatio: "16 / 10",
          }}
        >
          <img
            src={Services1}
            alt="Services"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  </div>
</section>

<section
  className="py-5"
  style={{
    background:
      "linear-gradient(180deg, #f7fbff 0%, #ffffff 52%, #f4f9ff 100%)",
  }}
>
  <div className="container py-4">
    <div className="text-center mb-5">
      <h2
        style={{
          color: "#0B5CAD",
          fontWeight: 800,
          marginBottom: "10px",
          fontSize: "clamp(1.8rem, 3.5vw, 2.4rem)",
        }}
      >
        Service Portfolio
      </h2>

      <p
        style={{
          maxWidth: "780px",
          margin: "0 auto",
          color: "#5b6777",
          lineHeight: "1.75",
          fontSize: "14px",
        }}
      >
        Our services are designed to support customers across planning,
        deployment, optimization, upgrades and long-term operational support.
      </p>
    </div>

    <div
      className="service-grid"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(6, 1fr)",
        gap: "10px",
        maxWidth: "860px",
        margin: "0 auto",
      }}
    >
      {serviceCards.map((item, index) => {
        let gridColumn = "span 2";

        if (serviceCards.length === 5) {
          if (index === 3) gridColumn = "2 / span 2";
          if (index === 4) gridColumn = "4 / span 2";
        }

        return (
          <div
            key={index}
            style={{
              display: "flex",
              justifyContent: "center",
              gridColumn,
            }}
          >
            <div
              style={{
                width: "100%",
                maxWidth: "260px",
                height: "290px",
                position: "relative",
              }}
            >
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundColor: item.color,
                  clipPath:
                    "polygon(50% 0%, 94% 22%, 94% 78%, 50% 100%, 6% 78%, 6% 22%)",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  inset: "6px",
                  background:
                    "linear-gradient(180deg, #fbfdff 0%, #f7fbff 45%, #f9fcff 100%)",
                  clipPath:
                    "polygon(50% 0%, 94% 22%, 94% 78%, 50% 100%, 6% 78%, 6% 22%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "45px 24px 35px",
                  textAlign: "center",
                  overflow: "hidden",
                }}
              >
                <div style={{ width: "85%" }}>
                  <h3
                    style={{
                      color: item.color,
                      fontWeight: 800,
                      fontSize: "15px",
                      marginBottom: "10px",
                      minHeight: "36px",
                      lineHeight: "1.2",
                    }}
                  >
                    {item.title}
                  </h3>

                  <ul style={{ paddingLeft: "16px", textAlign: "left", margin: 0 }}>
                    {item.points.map((p, i) => (
                      <li
                        key={i}
                        style={{
                          fontSize: "12px",
                          lineHeight: "1.4",
                          marginBottom: "5px",
                        }}
                      >
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  </div>

  <style>{`
    @media (max-width: 768px) {
      .service-grid {
        grid-template-columns: 1fr !important;
        max-width: 320px !important;
      }
      .service-grid > div {
        grid-column: auto !important;
      }
    }
  `}</style>
</section>

    <section
  className="py-5"
  style={{
    background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
  }}
>
  <div className="container py-4">
    <div className="row align-items-center gy-4">
      <div className="col-lg-6">
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "24px",
            padding: "34px",
            boxShadow: "0 12px 35px rgba(0,0,0,0.05)",
            borderLeft: "6px solid #1DA9E8",
          }}
        >
          <h2
            style={{
              color: "#0B5CAD",
              fontWeight: 800,
              marginBottom: "18px",
            }}
          >
            How Our Services Support Customers
          </h2>

          <p style={{ color: "#4a5568", lineHeight: "1.95" }}>
            Electromates’ service model goes beyond product or project
            delivery. It supports customers through planning, integration,
            commissioning, modernization and long-term operational
            maintenance.
          </p>

          <p
            style={{
              color: "#4a5568",
              lineHeight: "1.95",
              marginBottom: 0,
            }}
          >
            This service depth helps improve readiness, reduce downtime
            risks, support system upgrades and strengthen the performance
            of industrial and infrastructure solutions over time.
          </p>
        </div>
      </div>

      <div className="col-lg-6">
        <div
          style={{
            width: "100%",
            borderRadius: "24px",
            overflow: "hidden",
            position: "relative",
            aspectRatio: "16 / 10",
          }}
        >
          <img
            src={Services2}
            alt="Service Field Support"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  </div>
</section>

      <section className="py-5">
        <div className="container py-4">
          <h2
            style={{
              color: "#0B5CAD",
              fontWeight: 800,
              marginBottom: "24px",
              textAlign: "center",
            }}
          >
            Service Benefits
          </h2>

          <div className="row g-3">
            {serviceBenefits.map((item, index) => (
              <div className="col-sm-6 col-lg-4" key={index}>
                <div
                  style={{
                    backgroundColor: "#ffffff",
                    borderRadius: "18px",
                    padding: "20px",
                    boxShadow: "0 8px 20px rgba(11,92,173,0.06)",
                    color: "#2d3748",
                    fontWeight: 600,
                    height: "100%",
                    textAlign: "center",
                  }}
                >
                  {item}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container py-4">
          <div
            style={{
              background: "linear-gradient(135deg, #0B5CAD 0%, #1DA9E8 100%)",
              borderRadius: "28px",
              padding: "50px 30px",
              textAlign: "center",
              color: "#ffffff",
              boxShadow: "0 16px 40px rgba(11,92,173,0.20)",
            }}
          >
            <h2 style={{ fontWeight: 800, marginBottom: "14px" }}>
              Need End-to-End Service Support?
            </h2>
            <p
              style={{
                maxWidth: "760px",
                margin: "0 auto 24px",
                lineHeight: "1.85",
                color: "rgba(255,255,255,0.92)",
              }}
            >
              From design and commissioning to maintenance, upgrades and audits,
              Electromates supports customers across the complete lifecycle of
              industrial and sustainable systems.
            </p>

            <a
              href="/contact"
              className="btn"
              style={{
                backgroundColor: "#ffffff",
                color: "#0B5CAD",
                padding: "12px 28px",
                borderRadius: "30px",
                fontWeight: 700,
                border: "none",
              }}
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;